import type { GaApp } from '~/modules/app'

import { registerStore } from './register'

export const stores = (gaApp: GaApp) => {
  return {
    register: registerStore(gaApp),
  }
}
